import React from 'react';
import { Card, Typography } from 'antd';
import { MailOutlined } from '@ant-design/icons';
import ConvitesPanel from '../../components/community/ConvitesPanel';

const { Title, Text } = Typography;

// Sem CommunityLayout aqui de propósito: quem decide o wrapper é a rota em App.js.
// Rota do jogador (/player/invites, fora do <Layout> admin) embrulha em
// <CommunityLayout userType="player">, igual /player/dashboard, /player/profile etc.
// Rota do organizador (/community/invites) já vive dentro do <Layout onLogout=.../>
// admin (bloco user.profile === 'ORGANIZADOR'), igual /community/team e
// /community/invites/history — essas páginas não se embrulham em CommunityLayout,
// senão duplicaria sidebar/header.
export default function InvitesPage({ userType }) {
  return (
    <div style={{ padding: 16 }}>
      <Title level={4} style={{ margin: 0 }}><MailOutlined /> Convites</Title>
      <Text type="secondary">Gerencie convites recebidos e enviados.</Text>
      <Card style={{ marginTop: 16 }} bodyStyle={{ padding: 0 }}>
        <ConvitesPanel userType={userType} />
      </Card>
    </div>
  );
}
